import { registerPlugin } from '@capacitor/core';

export interface Sumsub {
    
    launch(options: { accessToken:string}): Promise<{ value: string }>;
}

const SumsubPlugin = registerPlugin<Sumsub>('SumsubPlugin');

export default SumsubPlugin;